// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"421":"ba0b201d","488":"4ad4de92"}[chunkId] + ".chunk.css";
};